import React, { useState } from "react";
import ViewJobs from "../components/Carrer/ViewJob";

import Aside from "../modules/SideNav/Aside";

function ViewJobsLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <div className={`app ${rtl ? "rtl" : ""} ${toggled ? "toggled" : ""}`}>
      <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      />
      <ViewJobs handleToggleSidebar={handleToggleSidebar} />
    </div>
  );
}

export default ViewJobsLayout;
